<ng-container *ngIf="loading">
  <div class="progress-loader">
    <div class="loading-spinner">
      <mat-spinner strokeWidth="3" diameter="150"></mat-spinner>
      <div
        style="
          position: relative;
          top: -95px;
          left: 3px;
          text-align: center;
          width: 150px;
        "
      ></div>
    </div>
  </div>
</ng-container>

<ng-container *ngIf="!isPreview">
  <div class="progress-loader" *ngIf="disableEdit">
    <div class="loading-spinner">
      <mat-spinner strokeWidth="3" diameter="150"></mat-spinner>
      <div
        style="
          position: relative;
          top: -95px;
          left: 3px;
          text-align: center;
          width: 150px;
        "
      ></div>
    </div>
  </div>
  <form [formGroup]="canvasForm">
    <app-header
      [canvasMode]="canvasMode"
      [canvasLayout]="canvasLayout"
      [loggedIn]="true"
      [hasEdit]="hasEdit"
      [canvasId]="parameterValue"
      [isFavorite]="isFavorite"
      [canvasType]="canvasType"
      [title]="title"
      [description]="description"
      [isDirty]="isDirty"
      [status]="status"
      [editable]="editable"
      [fixedHeader]="true"
      [canvasAccess]="canvasAccess"
      [disableEdit]="disableEdit"
    ></app-header>
    <div id="fixed" style="height: 60px; width: 100%"></div>
    <app-related-bar
      *ngIf="canvasType == 'dashboard' && canvasMode == 'view'"
      [canvasId]="parameterValue"
      [hasEdit]="canvasMode == 'view'"
      [module_id]="module_id"
    ></app-related-bar>
    <app-widget-bar
      *ngIf="canvasType == 'dashboard'"
      [customLinks]="customLinks"
      [hasEdit]="canvasMode == 'edit'"
      [canvasMode]="canvasMode"
    ></app-widget-bar>
  </form>
</ng-container>

<ng-container *ngIf="!isPreview && canvasMode == 'edit'">
  <form [formGroup]="canvasForm" [ngClass]="[disableEdit ? 'disableEdit' : '']">
    <mat-drawer-container
      class="report-container"
      *ngIf="!loading"
      [ngClass]="[canvasType == 'dashboard' ? 'dashboard' : '']"
    >
      <mat-drawer
        mode="side"
        position="start"
        opened
        class="left-side"
        [disableClose]="true"
        *ngIf="canvasLayout == false && canvasMode == 'edit'"
      >
        <app-data-field
          [(chartData)]="chartData"
          [charts]="data"
          [canvas_id]="parameterValue"
          [currentDataFields]="dataFields"
          [reportloading]="loading"
          [(sortFields)]="sortFields"
          [(filterFields)]="filterFields"
          [canvasOptions]="canvasOptions"
          [expanded]="false"
          [chartType]="chartType"
          [isVisible]="isVisible"
          [canAddModifiers]="canAddModifiers"
          (chartDataChange)="chartDataChangedHandler($event)"
          (sortFieldsChange)="sortFieldsChangeHandler($event)"
          (filterFieldsChange)="filterFieldsChangeHandler($event)"
          (openSettingsChange)="openSettingsChangedHandler($event)"
        ></app-data-field>

        <app-visualizations
          [charts]="data"
          (chartTypeChanged)="chartTypeChangedHandler($event)"
          (chartTypeAdded)="chartTypeAddedHandler($event)"
          (chartDataChange)="chartDataChangedHandler($event)"
          [selectedChartType]="selectedChartType"
          [canvasOptions]="canvasOptions"
        ></app-visualizations
      ></mat-drawer>

      <mat-drawer-content class="main" [ngClass]="containerWidth()">
        <app-canvas-items
          [isDirty]="isDirty"
          [loading]="loading"
          [selectedItem]="selectedItem"
          [chartData]="data"
          (selectChartChange)="selectChartChangedHandler($event)"
          (chartTextChange)="chartTextChangedHandler($event)"
          (addChartChange)="addChartChangedHandler($event)"
          [preview]="false"
          [canvasType]="canvasType"
          [canvasMode]="canvasMode"
          [canvasLayout]="canvasLayout"
        >
        </app-canvas-items>
      </mat-drawer-content>

      <mat-drawer
        mode="side"
        position="end"
        opened
        class="right-side"
        [disableClose]="true"
        *ngIf="canvasLayout == false && canvasMode == 'edit'"
      >
        <app-options
          [charts]="data"
          [currentDataFields]="dataFields"
          [manualChartColors]="manualChartColors"
          [visibleDataPoints]="visibleDataPoints"
          [appliedSeries]="appliedSeries"
          [workflows]="workflows"
          [canvasOptions]="canvasOptions"
          [groupFields]="groupFields"
          [currentFilterFields]="filterFields"
          [sortFields]="sortFields"
          [formatdata]="formatdata"
          [chartType]="chartType"
          [canAddModifiers]="canAddModifiers"
          [openFirst]="openFirst"
          [calculationOptions]="calculationOptions"
          (chartDataChange)="chartDataChangedHandler($event)"
          [chartData]="chartData"
          [isVisible]="isVisible"
        ></app-options>
      </mat-drawer>
    </mat-drawer-container>
  </form>
</ng-container>

<ng-container *ngIf="!isPreview && canvasMode == 'view'">
  <form [formGroup]="canvasForm">
    <div class="viewLayout">
      <app-canvas-items
        [isDirty]="isDirty"
        [loading]="loading"
        [selectedItem]="selectedItem"
        [chartData]="data"
        (selectChartChange)="selectChartChangedHandler($event)"
        (chartTextChange)="chartTextChangedHandler($event)"
        (addChartChange)="addChartChangedHandler($event)"
        [preview]="true"
        [canvasType]="canvasType"
        [canvasMode]="canvasMode"
        [canvasLayout]="canvasLayout"
      >
      </app-canvas-items>
    </div>
  </form>
</ng-container>

<ng-container *ngIf="isPreview">
  <div class="previewHeader" *ngIf="canvasForm">
    <h2>{{ canvasForm.get("title")?.value }}</h2>
    <p>{{ canvasForm.get("description")?.value }}</p>
    <br />
  </div>
  <div *ngIf="data" class="disabled">
    <app-canvas-items
      [chartData]="data"
      [preview]="true"
      [hasEdit]="false"
      [canvasType]="canvasType"
    >
    </app-canvas-items>
  </div>
</ng-container>
